import { useContext, useState } from "react"
import { InfoFiscaleContext } from "../context"

import { Header } from "../components/UI/Header"

import { Description } from "../components/UI/Description"
import { Icms } from "../components/UI/Icms"
import { Ipi } from "../components/UI/Ipi"
import { Pis } from "../components/UI/Pis"
import { Cofins } from "../components/UI/Cofins"
import { Issqn } from "../components/UI/Issqn"
import { Information } from "../components/UI/Information"

import { ContentInfoFiscal, CardInfoFiscal } from "./styles"
import { Div, AnimateCard } from "../../styles"
import { ProductContext } from "../../../context/ProductContext"
import { FiSave, FiTrash2 } from "react-icons/fi"

export function Taxes() {
  const { listRef } = useContext(ProductContext)
  const { enable, handleSaveOrUpdate, clear, assignValuesToTaxes } = useContext(InfoFiscaleContext)
  const [refSelected, setRefSelected] = useState(-1)

  function findRefById(id) {
    setRefSelected(id)
    if (!id || id === '-1') {
      clear()
      return
    }

    const result = listRef.find(x => String(x.id) === String(id))

    if (!result) {
      return;
    }

    assignValuesToTaxes(result)
  }

  function clearFiscal() {
    setRefSelected(-1)
    clear()
  }

  return (
    <ContentInfoFiscal className="fiscal-reference-editor">
      <div className="fiscal-reference-heading"><div><h3>Referência fiscal</h3><p>Selecione uma configuração existente ou preencha os impostos para este produto</p></div></div>
      <label className="fiscal-reference-select" htmlFor="fiscal-reference">
        <span>REF Fiscal</span>
        <select id="fiscal-reference" value={refSelected} onChange={(e) => findRefById(e.target.value)} className="form-select">
          <option value={-1} >---- Selecione ----</option>
          {listRef.map((value) => {
            return (
              <option key={value.id} value={value.id}>{value.ref} - {value.description}</option>
            )
          })}
        </select>
      </label>
      <Header />

      <AnimateCard>
        <CardInfoFiscal className="row animate fiscal-tax-content">
          <Div hidden={enable.description} className="animate">
            <Description />
          </Div>

          <Div hidden={enable.icms} className="animate">
            <Icms />
          </Div>

          <Div hidden={enable.ipi} className="animate">
            <Ipi />
          </Div>

          <Div hidden={enable.pis} className="animate">
            <Pis />
          </Div>

          <Div hidden={enable.cofins} className="animate">
            <Cofins />
          </Div>

          <Div hidden={enable.issqn} className="animate">
            <Issqn />
          </Div>

          <Div hidden={enable.information} className="animate">
            <Information />
          </Div>
        </CardInfoFiscal>

        <div className="fiscal-reference-actions"><button type="button" className="admin-secondary-button" onClick={clearFiscal}><FiTrash2 /> Limpar campos</button><button type="button" className="admin-primary-button" onClick={handleSaveOrUpdate}><FiSave /> Salvar configuração</button></div>
      </AnimateCard >

    </ContentInfoFiscal>
  )
}
